import { render, staticRenderFns } from "./NavDropdown.vue?vue&type=template&id=8053b620&scoped=true&"
import script from "./NavDropdown.vue?vue&type=script&lang=js&"
export * from "./NavDropdown.vue?vue&type=script&lang=js&"
import style0 from "./NavDropdown.vue?vue&type=style&index=0&id=8053b620&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8053b620",
  null
  
)

export default component.exports